export const SourceColumnType = {
    SELECT: "SELECT",
    NUMERIC: "NUMERIC",
    DATE: "DATE",
    CHECKBOX: "CHECKBOX",
} as const;

export type SourceColumnType = (typeof SourceColumnType)[keyof typeof SourceColumnType];
